import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FaqAccordionSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useTranslation();

  const faqs = [
    { question: t('threeStep.faq.q1'), answer: t('threeStep.faq.a1') },
    { question: t('threeStep.faq.q2'), answer: t('threeStep.faq.a2') },
    { question: t('threeStep.faq.q3'), answer: t('threeStep.faq.a3') },
    { question: t('threeStep.faq.q4'), answer: t('threeStep.faq.a4') },
    { question: t('threeStep.faq.q5'), answer: t('threeStep.faq.a5') },
  ];

  return (
    <section className="w-full bg-[#F0EFED] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-3xl mx-auto">
        <div className="flex flex-col items-center text-center gap-4 mb-12">
          <div className="flex items-center gap-3">
            <div className="w-8 h-px bg-[#7B1113]" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">{t('threeStep.faq.label')}</span>
            <div className="w-8 h-px bg-[#7B1113]" />
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A2A2A] leading-[1.15]">
            {t('threeStep.faq.heading')}
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-white overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-[#2A2A2A]">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-[#8A8A8A] text-lg transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-xs text-[#8A8A8A] font-light leading-[1.9]">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}